export const blockIconsDeviceDvr = (
	<span className='material-symbols-outlined'>dvr</span>
);
